import { Component, Input, Output, ElementRef, EventEmitter, OnInit } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'ImageModal',
    templateUrl: 'image-modal.component.html',
    styleUrls: ['image-modal.component.css']
})
export class ImageModal implements OnInit {
    public _element: any;
    public opened: boolean = false;
    public imgSrc: string;
    public currentImageIndex: number;
    public loading: boolean = false;
    public showRepeat: boolean = false;
    @Input('modalImages') public modalImages: any;
    @Input('imagePointer') public imagePointer: number;
    @Output('cancelEvent') cancelEvent = new EventEmitter<any>();
    constructor(public element: ElementRef) {
        this._element = this.element.nativeElement;
    }
    ngOnInit() {
        this.loading = true;
        if (this.imagePointer >= 0) {
            this.showRepeat = false;
            this.openGallery(this.imagePointer);
        } else {
            this.showRepeat = true;
        }
    }
    closeGallery() {
        this.opened = false;
        this.cancelEvent.emit(null);
    }
    prevImage() {
        this.loading = true;
        this.currentImageIndex--;
        if (this.currentImageIndex < 0) {
            this.currentImageIndex = this.modalImages.length - 1;
        }
        this.openGallery(this.currentImageIndex);
    }
    nextImage() {
        this.loading = true;
        this.currentImageIndex++;
        if (this.modalImages.length === this.currentImageIndex) {
            this.currentImageIndex = 0;
        }
        this.openGallery(this.currentImageIndex);

    }
    openGallery(index) {
        if (!index) {
            this.currentImageIndex = 1;
        }
        this.currentImageIndex = index;
        this.opened = true;
        for (var i = 0; i < this.modalImages.length; i++) {
            if (i === this.currentImageIndex) {
                this.imgSrc = this.modalImages[i].img;
                this.loading = false;
                break;
            }
        }
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/imageModal/image-modal.component.ts